import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { heroVideos } from '@/mocks/home';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % heroVideos.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const video = heroVideos[current];

  return (
    <section className="relative w-full h-[420px] md:h-[580px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={video.image}
          alt={video.title}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full h-full max-w-7xl mx-auto px-4 md:px-6 flex items-end pb-14 md:pb-20">
        <div className="w-full">
          <div className="flex items-center gap-2 mb-3">
            {video.tags.map((tag) => (
              <span
                key={tag}
                className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-primary-500/90 text-background-50"
              >
                {tag}
              </span>
            ))}
            <span className="text-sm text-background-50/80">{video.category}</span>
          </div>

          <h1 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-3">
            {video.title}
          </h1>

          <p className="text-sm md:text-base text-background-50/80 max-w-xl mb-4 line-clamp-2">
            {video.description}
          </p>

          <div className="flex items-center gap-4">
            <Link
              to={`/article/${video.slug}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-play-fill"></i>
              </div>
              立即观看
            </Link>
            <div className="flex items-center gap-1.5 text-background-50">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-star-fill text-accent-500"></i>
              </div>
              <span className="text-sm font-semibold">{video.rating}</span>
            </div>
          </div>

          <div className="flex items-center gap-2 mt-6">
            {heroVideos.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrent(index)}
                className={`h-1 rounded-full transition-all cursor-pointer ${
                  index === current
                    ? 'w-8 bg-primary-500'
                    : 'w-4 bg-background-50/40 hover:bg-background-50/60'
                }`}
                aria-label={`切换到第 ${index + 1} 张`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}